import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

const appendScheduleFields = (formData, data) => {
  if (data.schedule) {
    formData.append("schedule", JSON.stringify(data.schedule));
  }
};

export default class ReviewCrawlingSettingService extends BaseService {
  search = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return;
        }
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
        return;
      }
      searchParams.append(key, value);
    });
    return this.axios.get(API_ENDPOINTS.REVIEW_CRAWLING_SETTING_SEARCH, {
      params: searchParams,
    });
  };

  getDetail = ({ reviewCrawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_DETAIL.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      )
    );
  };

  getSettingFile = () => {
    return this.axios.get(API_ENDPOINTS.REVIEW_CRAWLING_SETTING_GET_SETTING_FILE);
  };

  deleteSettingFile = () => {
    return this.axios.get(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_DELETE_SETTING_FILE_DRAFT
    );
  };

  validateSettingFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return this.axios.post(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_VALIDATE_SETTING_FILE,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  create = (data) => {
    const formData = new FormData();
    if (data.file) {
      formData.append("file", data.file);
    }
    formData.append("title", data.title);
    formData.append("executionType", data.executionType);
    appendScheduleFields(formData, data);
    return this.axios.post(API_ENDPOINTS.REVIEW_CRAWLING_SETTING_CREATE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  update = (data) => {
    return this.axios.put(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_UPDATE.replace(
        "{reviewCrawlingSettingId}",
        data.reviewCrawlingSettingId
      ),
      data
    );
  };

  delete = ({ reviewCrawlingSettingId }) => {
    return this.axios.delete(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_DELETE.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      )
    );
  };

  execute = ({ reviewCrawlingSettingId, forceQueue }) => {
    return this.axios.post(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_EXECUTE.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      ),
      { forceQueue: !!forceQueue }
    );
  };

  cancel = ({ reviewCrawlingSettingId }) => {
    return this.axios.post(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_CANCEL.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      )
    );
  };

  getCurrent = ({ reviewCrawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_CURRENT.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      )
    );
  };

  getRuns = ({ reviewCrawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_RUNS.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      )
    );
  };

  importExcel = ({ reviewCrawlingSettingId, file }) => {
    const formData = new FormData();
    formData.append("file", file);
    return this.axios.post(
      API_ENDPOINTS.REVIEW_CRAWLING_SETTING_IMPORT.replace(
        "{reviewCrawlingSettingId}",
        reviewCrawlingSettingId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };
}
